import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var FileDigit = createReactComponent("FileDigit", ["svg", defaultAttributes, [["path", {
  d: "M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4",
  key: "19r7vg"
}], ["path", {
  d: "M14 2v6h6",
  key: "1yykud"
}], ["path", {
  d: "M10 12h2v6",
  key: "hsb8tw"
}], ["rect", {
  x: "2",
  y: "12",
  width: "4",
  height: "6",
  key: "ma9s1h"
}], ["path", {
  d: "M10 18h4",
  key: "139y51"
}]]]);
export default FileDigit;